module.exports = __webpack_public_path__ + "static/media/kitchen-close-icon.0b28761e.png";